/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomField } from '../../model/customfieldsresponse';
declare var $: any;
@Component({
  selector: 'zsd-currencyfield',
  templateUrl: '../../view/customfields/currencyfield.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class CurrencyFieldComponent implements OnInit {

  @Input('parentForm') public parentForm: FormGroup;
  @Input() customField: CustomField;
  @Input('fromQuickCall') public fromQuickCall: boolean;

  currencyInfoForm: FormGroup;
  // currencyValue = '';
  required = false;
  dscEnable = false;
  description = '';
  currencyFieldFocus = false;
  customerEditable = false;
  currencyFormattedValue;
  currencyFormat = '';
  constructor(public formBuilder: FormBuilder) {
  }

  ngOnInit() {
    if (this.customField.dscEnable === 1) {
      this.dscEnable = true;
      this.description = this.customField.description;
    }

    if (this.customField.required === 1) {
      this.required = true;
    }
    if (this.customField.clientEditable === 1) {
      this.customerEditable = true;
    }
    if (this.customField.defaultValue != null && this.customField.defaultValue.length > 0) {
      // this.currencyValue = this.toHTML(this.customField.defaultValue);
      // this.currencyFormattedValue = this.currencyValue;
      this.currencyFormattedValue = this.getFormattedCurrency(this.toHTML(this.customField.defaultValue));
    }

    let currencyName = this.customField['currency'].shortName;
    switch (currencyName) {
      case 'GBP':
        this.currencyFormat = '£';
        break;
      case 'USD':
        this.currencyFormat = '$';
        break;
      case 'CAD':
        this.currencyFormat = 'C$';
        break;
      case 'CNY':
        this.currencyFormat = '¥';
        break;
      case 'DKK':
        this.currencyFormat = 'KR';
        break;
      case 'EUR':
        this.currencyFormat = '€';
        break;
      case 'HKD':
        this.currencyFormat = 'HK$';
        break;
      case 'NZD':
        this.currencyFormat = 'NZ$';
        break;
      case 'ZAR':
        this.currencyFormat = 'R';
        break;
      case 'CHF':
        this.currencyFormat = 'CHF';
        break;
      default:
        this.currencyFormat = '';
    }

    this.currencyInfoForm = this.formBuilder.group({
      data: this.formBuilder.control({ value: '', disabled: !this.customerEditable })
    });

    if (this.customField.required === 1) {
      this.currencyInfoForm.get('data').setValidators(Validators.required);
    }

    if (this.parentForm) {
      this.parentForm.addControl(this.customField.fieldId + '', this.currencyInfoForm);
    }
    this.currencyInfoForm.get('data').setValue(this.currencyFormattedValue);
    this.currencyInfoForm.updateValueAndValidity();
    this.parentForm.setControl(this.customField.fieldId + '', this.currencyInfoForm);

    // Setup for description jquery
    if (this.customField.dscEnable === 1) {
      $(document).ready(function () {
        $('[data-toggle=' + this.customField.fieldId + ']').popover();
      }.bind(this));
    }
  }
  toHTML(input): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.textContent;
  }
  currencyValueEmpty() {
    return this.currencyInfoForm.get('data').value === '';
  }

  currencyValueUpdate() {
    this.currencyInfoForm.get('data').setValue(this.currencyFormattedValue);
    this.currencyInfoForm.updateValueAndValidity();
    this.parentForm.setControl(this.customField.fieldId + '', this.currencyInfoForm);
  }



  // function for Formatting the Currency Value
  // If entered some Text It will convert it to 0.00

  currencyValueFormatter() {
    let currencyInput = this.currencyFormattedValue;
    currencyInput = currencyInput.replace(/[^\d\.\-eE+]/g, '');
    currencyInput = currencyInput ? parseFloat(currencyInput) : 0;
    currencyInput = !currencyInput ? 0 : currencyInput;
    this.parentForm.setControl(this.customField.fieldId + '', this.currencyInfoForm);
    this.currencyFormattedValue = (currencyInput === 0) ? '0.00' : currencyInput.toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    this.currencyInfoForm.get('data').setValue(this.currencyFormattedValue);
    this.currencyInfoForm.updateValueAndValidity();
  }

  getFormattedCurrency(currencyInput) {
    currencyInput = currencyInput.replace(/[^\d\.\-eE+]/g, '');
    currencyInput = currencyInput ? parseFloat(currencyInput) : 0;
    currencyInput = !currencyInput ? 0 : currencyInput;
    return (currencyInput === 0) ? '0.00' : currencyInput.toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

}
